export default __webpack_public_path__ + "static/media/pennybun1.aaae2cf6.png";